import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

//banner轮播
var bannerswiper = new Swiper(".section1 .mySwiper", {
	watchOverflow: true,
	effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  pagination: {// 分页
    el: ".section1 .swiper-pagination",
    clickable: true,
  },
	on: {
    init: function(swiper){
			$('.section1 .swiper video')[0].play()
    }, 
  },
})

// about 轮播
var abswiper1 = new Swiper(".section2 .right-img .swiper1", {
	watchOverflow: true,
	allowTouchMove: false,
	observer: true, 
	observeParents: true,
	effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
	autoplay: { // 自动切换
    delay: 5000,
    stopOnLastSlide: false,//当切换到最后一个slide时是否停止自动切换。（loop模式下无效）
    disableOnInteraction: false,//用户操作swiper之后，是否禁止autoplay。默认为true：停止。
    waitForTransition: false,//等待过渡完毕，true:自动切换会在slide过渡完毕后才开始计时。
  },
	on: {
		transitionStart: function(){
			$(".section2 .right-img .mask-ani").addClass('active')
		},
		transitionEnd: function(){
			setTimeout(function(){
				$(".section2 .right-img .mask-ani").removeClass('active')
			},1000)
		},
		slideChangeTransitionStart: function(){
      abswiper2.slideTo(this.realIndex)
    },
  },
})
var abswiper2 = new Swiper(".section2 .right-img .swiper2", {
	watchOverflow: true,
	allowTouchMove: false,
	observer: true, 
	observeParents: true,
	effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
})
abswiper1.autoplay.stop();

// 产品
$(".section5 .swiper-cont .swiper .swiper-slide").eq(0).addClass('active')
var proswiper1 = new Swiper(".section5 .swiper-cont .swiper", {
	slidesPerView : 1.2,
	slidesPerGroup : 1,
	spaceBetween: 15,
	breakpoints: {
    768: {
      slidesPerView : 3,
			slidesPerGroup : 3,
			spaceBetween: 20,
    },
    1280: {
      slidesPerView : 4,
			slidesPerGroup : 4,
			spaceBetween: 35,
    }
  },
	navigation: {//按钮
    nextEl: ".section5 .swiper-button-next",
    prevEl: ".section5 .swiper-button-prev",
  },
})

$(".section5 .swiper-cont .swiper .swiper-slide").on('click',function(){
	let index = $(this).index()
	$(this).addClass('active').siblings().removeClass('active')
  proswiper2.slideTo(index)
  proswiper3.slideTo(index)
	proswiper4.slideTo(index)
})

var proswiper2 = new Swiper(".section6 .textswiper", {
	watchOverflow: true,
	allowTouchMove: false,
	observer: true, 
	observeParents: true,
	effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  on:{
    transitionStart: function(){
			$(".section6 .textswiper .mask-ani").addClass('active')
		},
		transitionEnd: function(){
			setTimeout(function(){
				$(".section6 .textswiper .mask-ani").removeClass('active')
			},500)
		},
  }
})
var proswiper3 = new Swiper(".section6 .imgswiper", {
  speed: 600,
	watchOverflow: true,
	allowTouchMove: false,
	observer: true, 
	observeParents: true,
	effect : 'fade',
})
var proswiper4 = new Swiper(".section7 .brand-swiper", {
  speed: 600,
	watchOverflow: true,
	allowTouchMove: false,
	observer: true, 
	observeParents: true,
	effect : 'fade',
	fadeEffect: {
    crossFade: true,
  },
})


let swipers = $('.section7 .brand-swiper .mySwiper');
for(let i = 0; i < swipers.length; i++){
    new Swiper(swipers[i], {
			speed: 600,
			slidesPerView: 1,
			slidesPerGroup: 1,
			spaceBetween: 0,
      watchOverflow: true,
			breakpoints: { //响应式
				768: {  //当屏幕宽度大于等于768 
					slidesPerView: 2,
					slidesPerGroup: 2,
					spaceBetween: 50
				},
				1024: {  //当屏幕宽度大于等于768 
					slidesPerView: 3,
					slidesPerGroup: 3,
					spaceBetween: 50
				},
				1280: {  //当屏幕宽度大于等于1280
					slidesPerView: 3,
					slidesPerGroup: 3,
					spaceBetween: 150
				}
			},
      navigation: {//按钮
        nextEl: $(swipers[i]).siblings('.swiper-button-next')[0],
        prevEl: $(swipers[i]).siblings('.swiper-button-prev')[0],
      },
			pagination: {// 分页
				el: $(swipers[i]).siblings('.swiper-pagination')[0],
				clickable: true,
				dynamicBullets: true,
			},
    });
}

// 图册
var vehiclesswiper = new Swiper(".section8 .swiper", {
  speed: 600,
	loop: true,
	centeredSlides: true,
	slidesPerView: 1.2,
	effect: "coverflow",
	coverflowEffect: {
		rotate: 0,
		stretch: 0,
		depth: 200,
		modifier: 2,
		slideShadows: true,
	},
	breakpoints: {
    768: {
      slidesPerView: 1.65,
    },
  },
	autoplay: { // 自动切换
    delay: 5000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
    waitForTransition: false,
  },
	navigation: {//按钮
    nextEl: ".section8 .swiper-button-next",
    prevEl: ".section8 .swiper-button-prev",
  },
})

$(document).scroll(function () {
  let scroH = $(document).scrollTop(); //滚动高度
  let viewH = $(window).height(); //可见高度
  let abswiperTop = $('.section2 .right-img').offset().top;

	$('.section1 .swiper video')[0].play()
	$('.section4 video')[0].play()

  if (scroH > abswiperTop - viewH) {
		$('.section2 .right-img .swiper .mask-init').addClass('active')
    abswiper1.autoplay.start();
  }else{
		abswiper1.autoplay.stop();
	}

  let proswiperTop = $('.section6 .textswiper').offset().top;
  if (scroH > proswiperTop - viewH) {
		$('.section6 .textswiper .mask-init').addClass('active')
  }

});

var mouseover_tid = [];
var mouseout_tid = [];
$(document).ready(function () {
  $(".section7 a").each(function (index) {
    $(this).hover(
      // 鼠标进入
      function () {
        var _self = this;
        // 停止卷起事件
        clearTimeout(mouseout_tid[ index ]);
        // 当鼠标进入超过 0.2 秒, 展开菜单, 并记录到线程 ID 中
        mouseover_tid[ index ] = setTimeout(function () {
					let tLenght = $(_self).find('.t').outerWidth()
					let pLenght = $(_self).find('p').outerWidth()

					if (pLenght > tLenght) {
						var d = pLenght - tLenght;
						$(_self).find('p').css({transform:'translateX(-'+ d +'px)',transition:'transform '+ d*.05 +'s linear'})
					}
        }, 201);
      },
      // 鼠标离开
      function () {
        var _self = this;
        // 停止展开事件
        clearTimeout(mouseover_tid[ index ]);
        // 当鼠标离开超过 0.2 秒, 卷起菜单, 并记录到线程 ID 中
        mouseout_tid[ index ] = setTimeout(function () {
					$(_self).find('p').css({transform:'translateX(0px)',transition:'transform 0s linear'})
        }, 201);
      });
    });
});